import { render, staticRenderFns } from "./killipClassification.vue?vue&type=template&id=73b1a5cf&scoped=true&"
import script from "./killipClassification.vue?vue&type=script&lang=js&"
export * from "./killipClassification.vue?vue&type=script&lang=js&"
import style0 from "./killipClassification.vue?vue&type=style&index=0&id=73b1a5cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b1a5cf",
  null
  
)

export default component.exports